var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GraphQLClient } from 'graphql-request';
import { appEnv } from '../env';
import { getSdk } from './schema';
import { getSdk as getSdkAuth } from './schema-auth';
import { getSdk as getSdkAccount } from './schema-account';
var endpoint = appEnv.server.url;
export var gqlClient = new GraphQLClient("".concat(endpoint, "/graphql"), { credentials: 'include' });
export var gqlSdk = getSdk(gqlClient);
export var gqlClientAuth = new GraphQLClient("".concat(appEnv.server.authUrl, "/graphql"), { credentials: 'include' });
export var gqlSdkAuth = getSdkAuth(gqlClientAuth);
export var gqlClientAccount = new GraphQLClient("".concat(appEnv.server.accountUrl, "/graphql"), { credentials: 'include' });
export var gqlSdkAccount = getSdkAccount(gqlClientAccount);
export var restClient = {
    login: function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var email, password, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = input.email, password = input.password;
                        return [4 /*yield*/, fetch("".concat(endpoint, "/auth/login"), {
                                method: 'POST',
                                credentials: 'include',
                                headers: [
                                    ['cache-control', 'no-cache'],
                                    ['Content-Type', 'application/json'],
                                ],
                                body: JSON.stringify({ email: email, password: password }),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                }
            });
        });
    },
    loginJwt: function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var email, password, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = input.email, password = input.password;
                        return [4 /*yield*/, fetch("".concat(endpoint, "/auth/login-jwt"), {
                                method: 'POST',
                                credentials: 'include',
                                headers: [
                                    ['cache-control', 'no-cache'],
                                    ['Content-Type', 'application/json'],
                                ],
                                body: JSON.stringify({ email: email, password: password }),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                }
            });
        });
    },
    logout: function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(endpoint, "/auth/logout"), {
                            method: 'GET',
                            credentials: 'include',
                            headers: [['cache-control', 'no-cache']],
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                }
            });
        });
    },
    // async logout2() {
    //   const response = await fetch(
    //     `${appEnv.server.ssoUrl}/logout?ref=${encodeURIComponent(`${appEnv.server.websiteUrl}/`)}`,
    //     {
    //       method: 'GET',
    //       credentials: 'include',
    //       headers: [['cache-control', 'no-cache']],
    //     },
    //   )
    //   return response.ok
    // },
};
